export default __webpack_public_path__ + "static/media/logo.ae21fe9f.png";